import { JSX } from "react";
import { SegmentSeparator } from "./SegmentSeparator";

/** Renders the provided text and replaces any "§" with the icon used to separate namespash path segments. */
function SegmentSeparated(props: { text: string }): JSX.Element {
  const { text } = props;

  const output: JSX.Element[] = [];
  let position = 0;
  let keepGoing = true;
  do {
    const slash = text.indexOf("\u00A7", position); // §
    if (slash >= 0) {
      const sub = text.substring(position, slash);
      output.push(
        <span key={output.length}>{sub}</span>,
      );
      output.push(
        <SegmentSeparator key={output.length} />,
      );
      position = slash + 1;
    } else {
      const sub = text.substring(position);
      output.push(
        <span key={output.length}>{sub}</span>,
      );
      keepGoing = false;
    }
  } while (keepGoing);

  return <>{output}</>;
}

export { SegmentSeparated };
